// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sBooA","title":"Info_title__1A5hp","links":"Info_links__2h4HC","link":"Info_link__2OEhq","logo":"Info_logo__2hJhg"};